import PagePlayer from './pages/PagePlayer.js';
import ServiceManager from './3x1010/services/ServiceManager.js';
import PageCommon from './pages/PageCommon.js'
export default class PlayerFactoryManager {
	static factory(cls) {
		return new PlayerFactoryManager.classes[cls]();
	}

}
// PAGINE
PlayerFactoryManager.classes = {
	PageCommon,
	PagePlayer
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon; 